module.exports = __webpack_public_path__ + "fonts/1bccde26f4b96e8e8ebb8cdf4f97c500.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/sign-in.svg
// module id = 2010
// module chunks = 0